import React from 'react'

export const HotTopicIcon = () => (
  <span className="Question-icon-fire" role="img" aria-label="In hot topic">
    🔥
  </span>
)

export default HotTopicIcon
